import type { FileObject } from 'back-office/services/base-document';
import type DocumentModelCommon from 'common/addon/models/document';
import type { Relation } from './file-to-form';
import { fileToFormData } from './file-to-form';
import type ProductModel from 'back-office/models/product';
import type ActionModel from 'back-office/models/action';
import type CoverService from 'back-office/services/cover';
import type FormatorImageService from 'back-office/services/formator-image';
import type OgImageService from 'back-office/services/og-image';

export async function saveFile(
  action: ActionModel | ProductModel,
  file: FileObject | null | undefined,
  model: DocumentModelCommon | undefined,
  service: CoverService | OgImageService | FormatorImageService,
  relation: Relation
) {
  if (file && fileToFormData(file, relation)) {
    return service.save(fileToFormData(file, relation) as FormData);
  }
  if (action.formatorImage !== undefined && file === undefined) {
    await model?.destroyRecord();
  }
}
